import React, { useState, useRef, useEffect } from "react"
import propTypes from "prop-types"
import { Breadcrumb as CBreadcrumb, BreadcrumbItem } from "@chakra-ui/react"

import { Link } from "../Link"
import { TextSM } from "../Typography"

export const Breadcrumb = ({ items: initialItems, ...restProps }) => {
  const [showEllipsis, setShowEllipsis] = useState(true)
  const breadcrumbRef = useRef()

  useEffect(() => {
    const handleOutsideClick = event => {
      if (!breadcrumbRef?.current?.contains(event.target)) setShowEllipsis(true)
    }

    document.addEventListener("click", handleOutsideClick)
    return () => {
      document.removeEventListener("click", handleOutsideClick)
    }
  }, [])

  const ellipsisItem = {
    label: "…",
    href: "#",
    onClick: event => {
      event.preventDefault()
      setShowEllipsis(false)
    },
  }
  const items =
    showEllipsis && initialItems.length > 3
      ? [initialItems[0], ellipsisItem, ...initialItems.slice(-2)]
      : initialItems

  return (
    <CBreadcrumb ref={breadcrumbRef} {...restProps}>
      {items.map(({ label, ...item }, index) => (
        <BreadcrumbItem key={item.id || index} data-testid="breadcrumb-item">
          {item.href ? (
            <Link opacity={0.6} {...item}>
              {label}
            </Link>
          ) : (
            <TextSM {...item}>{label}</TextSM>
          )}
        </BreadcrumbItem>
      ))}
    </CBreadcrumb>
  )
}

Breadcrumb.propTypes = {
  items: propTypes.arrayOf(
    propTypes.shape({
      label: propTypes.string.isRequired,
      href: propTypes.string,
    })
  ).isRequired,
}
